"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFinderWishlist = exports.trackFinderCardClick = exports.trackFinderResults = exports.trackFinderCards = exports.trackFinderVote = exports.trackFinderRestart = exports.trackFinderError = exports.trackFinderInit = exports.WishlistAction = exports.VoteType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const trackTravelDates_1 = require("./trackTravelDates");
var VoteType;
(function (VoteType) {
    VoteType["positive"] = "positive";
    VoteType["negative"] = "negative";
    VoteType["wishlist"] = "wishlist";
})(VoteType || (exports.VoteType = VoteType = {}));
var WishlistAction;
(function (WishlistAction) {
    WishlistAction["add"] = "add";
    WishlistAction["remove"] = "remove";
})(WishlistAction || (exports.WishlistAction = WishlistAction = {}));
const trackFinderInit = (data) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.init',
        eventMetadata: {
            travelPeriod: data.travelPeriod
                ? (0, trackTravelDates_1.mapTravelDatesPayloadToEventMetadata)(data.travelPeriod)
                : undefined,
            withChildren: data.withChildren,
            productFeatures: data.productFeatures,
        },
        _clear: true,
    });
};
exports.trackFinderInit = trackFinderInit;
const trackFinderError = () => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.error',
        eventMetadata: {},
        _clear: true,
    });
};
exports.trackFinderError = trackFinderError;
const trackFinderRestart = () => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.restart',
        eventMetadata: {},
        _clear: true,
    });
};
exports.trackFinderRestart = trackFinderRestart;
const trackFinderVote = (action) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.vote',
        eventMetadata: {
            action: action.type,
            card: action.card,
        },
        _clear: true,
    });
};
exports.trackFinderVote = trackFinderVote;
const trackFinderCards = (action) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.show',
        eventMetadata: Object.assign(Object.assign({}, action), { bd4t: {
                info: Object.assign({}, action.bd4t),
            } }),
        _clear: true,
    });
};
exports.trackFinderCards = trackFinderCards;
const trackFinderResults = (action) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.results',
        eventMetadata: Object.assign(Object.assign({}, action), { bd4t: {
                info: Object.assign({}, action.bd4t),
            } }),
        _clear: true,
    });
};
exports.trackFinderResults = trackFinderResults;
const trackFinderCardClick = (card) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.click',
        eventMetadata: {
            card,
        },
        _clear: true,
    });
};
exports.trackFinderCardClick = trackFinderCardClick;
const trackFinderWishlist = (action, cards) => {
    (0, libs_tracking_events_1.track)({
        event: '🚀 hf.wishlist',
        eventMetadata: {
            action,
            cards,
        },
        _clear: true,
    });
};
exports.trackFinderWishlist = trackFinderWishlist;
//# sourceMappingURL=trackHolidayFinder.js.map